<template>
    <v-form name="set-status-form">
        <div class="grid"
             style="margin-top:5px">

            <FormSelect fieldName="status_id"
                        label="Status"
                        validation="required"
                        :options="select?.statuses"
                        v-model:field="status_id" />
        </div>
        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="changeStatus"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-solid fa-dolly"></i><span>{{ __('Change status') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import Button from 'primevue/button';
import FormSelect from '@crud/FormSelect.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation, prepareSelect } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    selectedRows: Array,
    formProps: Object,
    currentStatusId: Number,
})

const isChangeStatusModalOpen = defineModel('isChangeStatusModalOpen')
const status_id = ref(props.currentStatusId)
const options = ["statuses"];
const select = ref(null);

// -----------------------------------------------------

onBeforeMount(async () => {
    select.value = await prepareSelect(options, null, null, { 'statuses': { 'status_category': 'STA_COST' } })
})

// -----------------------------------------------------

const cancel = () => {
    isChangeStatusModalOpen.value = false
}
// -----------------------------------------------------

const changeStatus = async () => {
    const formData = {
        'ids': props.selectedRows.map(row => row.id),
        'status_id': status_id.value,
    }

    if (validation(formData, 'set-status-form')) {
        const response = await getFromRoute('cost-status-set', formData, 'post');
        screenMessage({ ...response })

        isChangeStatusModalOpen.value = false
        props.formProps.clearSelection()
        props.formProps.getLazyData()
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
